import { post, get, deletefn, putfun } from './http.js'
export default {
    // 发表提问
    async publishQuestions (params) {
        return await post ('/bbs/question',params)
    },
    // 提问列表
    async answerList (params) {
        return await get ('/bbs/question',params)
    },
    // 我的提问列表
    async ownerAnswerList (params) {
      return await get ('/bbs/owner-question',params)
    },
    // 我的回复列表
    async owenReplyList (params) {
      return await get ('/bbs/owner-reply',params)
    },
    // 提问编辑
    async answerCompile (params) {
        return await get (`/bbs/question/${params}`)
    },
    // 提问删除
    async answerDelete (params) {
        return await deletefn (`/bbs/question/${params}`)
    },
    //提问更新
    async answerUpdate (params) {
        return await putfun (`/bbs/question/${params.id}`,params)
    },
    // 回复新增
    async answerReply (params) {
        return await post ('/bbs/reply',params)
    },
    // 回复删除
    async replyDelete (params) {
        return await deletefn (`/bbs/reply/${params}`)
    },
    // 回复列表
    async replyList (params) {
        return await get ('/bbs/reply',params)
    },
    // 分类列表
    async categoryList (params) {
        return await get ('/bbs/category',params)
    },
    // 帖子收藏
    async collect (params) {
        return await post ('/common/collects',params)
    },
}



// WEBPACK FOOTER //
// ./src/request/community.js